import React from "react";
import Newsletter_35 from "../component/Newsletter_35";

function Newsletter_35Container() {
  return <Newsletter_35 />;
}

export default Newsletter_35Container;
